export default {"src":"/_next/static/media/large-clock.520e8568.svg","height":80,"width":80};